<lib-card
  [fullScreenMode]="true"
  (fullScreenChange)="fullScreenChanges($event)"
  id="kpi-analytics-pie-chart-{{ id }}"
>
  <lib-card-header>
    <div class="row mb-3 justify-content-between align-items-center">
      <div>
        <strong>
          {{ dataDisplayName | translate }} {{ showKpiSelected ? (kpiSelected?.displayName | translate) : '' }}
        </strong>
      </div>
      <ul class="nav d-flex align-items-center">
        <li class="nav-item text-primary font-size-normal order-0">
          @if (mainAnalyticsData?.length > 0) {
            <lib-select
              id="kpi-analytics-pie-chart-select-option"
              [options]="dropdownOptionsLabels"
              [label]="labelSelectedOption"
              [border]="'custom-border'"
              [classes]="'font-size-normal-small text-primary h-100 text-left'"
              [notBold]="true"
              [fullWidth]="false"
              [itemClasses]="'font-size-normal-small'"
              [doNotTranslate]="false"
              [container]="''"
              [size]="'small'"
              (selectedChanged)="changeOption($event)"
            ></lib-select>
          }
        </li>
        @if (showExportButton) {
          <li class="nav-item ml-2">
            <app-export-chart
              [data]="true"
              [useTable]="false"
              chartId="kpi-analytics-pie-chart-{{ id }}"
              fileName="{{ dataDisplayName | translate }} {{
                showKpiSelected ? (kpiSelected?.displayName | translate) : ''
              }}"
              [dataToExport]="prepareDataToExport"
            ></app-export-chart>
          </li>
        }
      </ul>
    </div>
  </lib-card-header>

  <lib-card-body>
    @if (!mainAnalyticsData || mainAnalyticsData.length === 0) {
      <app-loading-and-no-data-template
        [isLoading]="!mainAnalyticsData"
        [height]="200"
      ></app-loading-and-no-data-template>
    } @else {
      <div
        class="row h-100"
        #contentWrapper
      >
        <div class="col-12 col-sm-4">
          <div class="w-100">
            <highcharts-chart
              [id]="id"
              class="w-100 d-block"
              [Highcharts]="highcharts"
              [options]="chartOptions"
              [callbackFunction]="chartCallback"
            ></highcharts-chart>
          </div>
        </div>
        <div class="col-12 col-sm-8">
          @if (chartDatasets.length > 0) {
            <div
              class="right p-1 pl-3 mt-3 mt-mb-0"
              [style.height]="isFullScreenMode ? 'auto' : chartContainerSize + 'px'"
              #rightSide
            >
              <div class="p-2 kpi kpi-total rounded mb-2">
                <div class="row">
                  <div class="col-6 font-weight-bold text-primary">{{ 'KPI.PARK.TOTAL' | translate }}</div>
                  <div class="col-6 text-right">
                    @if (kpiSelected?.isDuration) {
                      <span
                        class="font-weight-bold text-primary"
                        [matTooltip]="chartPercentagesSum | shortDuration: dataUnit ?? 'milliseconds'"
                      >
                        {{
                          dataUnit
                            ? (chartPercentagesSum | duration: true : dataUnit)
                            : (chartPercentagesSum | duration: true)
                        }}
                      </span>
                    } @else {
                      <span class="font-weight-bold text-primary">
                        {{ chartPercentagesSum | number: '1.0-0' | customNumberFormat }} {{ kpiSelected?.objectSign }}
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div class="row">
                @for (row of mainAnalyticsData; track $index; let i = $index) {
                  <div
                    class="mt-2"
                    [ngClass]="{ 'kpi-items-fullscreen': isFullScreenMode, 'kpi-items': !isFullScreenMode }"
                  >
                    <div
                      class="p-2 font-weight-bold kpi kpi-item rounded"
                      [ngStyle]="{ 'border-left': '5px solid ' + row?.color }"
                    >
                      <div class="row justify-content-between align-items-center w-100 flex-nowrap">
                        <div
                          class="text-primary"
                          style="width: calc(100% - 51px)"
                        >
                          <span
                            class="cut-text"
                            (mouseover)="showPopup($event, i)"
                            (mouseleave)="hidePopup($event, i)"
                          >
                            @if (planningModuleView === 'planning_analytics') {
                              {{ 'PLANNING.OVERVIEW.' + row?.name.toUpperCase().split(' ')[0] | translate }}
                            }
                            @if (planningModuleView !== 'planning_analytics') {
                              {{ row?.name }}
                            }
                          </span>
                        </div>
                        <div class="d-flex flex-nowrap align-items-center">
                          @if (chartDatasets[0]?.data[i] >= 1) {
                            <span class="pr-1 text-primary">
                              {{ chartDatasets[0]?.data[i] | number: '1.0-0' | customNumberFormat }}%
                            </span>
                          }
                          @if (chartDatasets[0]?.data[i] < 1 && chartDatasets[0]?.data[i] >= 0.1) {
                            <span class="pr-1 text-primary">
                              {{ chartDatasets[0]?.data[i] | number: '1.1-1' | customNumberFormat }}%
                            </span>
                          }
                          @if (chartDatasets[0]?.data[i] < 0.1) {
                            <span class="pr-1 text-primary">&lt;{{ '0.1' | customNumberFormat }}%</span>
                          }
                          <mat-checkbox
                            [(ngModel)]="checkedKpis[i]"
                            (ngModelChange)="onCheckedChanges()"
                          ></mat-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (showInfoPopup) {
                  <div
                    class="card popup position-fixed shadow-sm p-1"
                    style="z-index: 50000; max-height: 350px"
                    [style.top.px]="popupTop"
                    [style.left.px]="popupLeft"
                  >
                    <div class="container text-primary">
                      {{ popupText }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  </lib-card-body>
</lib-card>
